import React from 'react'
import { Route, IndexRoute } from 'react-router'

import App from './containers/app'
import EmailSignUpPage from './containers/pages/email-sign-up-page/email-sign-up-page'
import SignInPage from './containers/pages/sign-in-page/sign-in-page'
import SignUpPage from './containers/pages/sign-up-page/sign-up-page'
import SignOutPage from './containers/pages/sign-out-page/sign-out-page'
import ForgotPasswordPage from './containers/pages/forgot-password-page/forgot-password-page'
import UpdatePasswordPage from './containers/pages/update-password-page/update-password-page'
import AccountDetailsPage from './containers/pages/account-details-page/account-details-page'
import Error404Page from './containers/pages/error-404-page/error-404-page'
import Error500Page from './containers/pages/error-500-page/error-500-page'

export default (
  <Route component={App} path="/">
    <IndexRoute component={SignUpPage} />
    <Route path="emailsignup" component={EmailSignUpPage} />
    <Route path="signup" component={SignUpPage} />
    <Route path="signin" component={SignInPage} />
    <Route path="signout" component={SignOutPage} />
    <Route path="forgotpwd" component={ForgotPasswordPage} />
    <Route path="update-password" component={UpdatePasswordPage} />
    <Route path="accountdetails" component={AccountDetailsPage} />
    <Route path="error404" component={Error404Page} />
    <Route path="error500" component={Error500Page} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js